import {BaseModel} from "../base.model";

export interface SplitOrderType extends BaseModel {
  
}

export const defaultSplitOrderType: Readonly<SplitOrderType> = {};